import { ModalWindow } from "@core/VisualComponents/ModalWindow/ModalWindow";
import { CreateOrEditEntity, ICreateOrEditEntityCommands } from "./CreateOrEditEntity";
import { useRef, useState } from "react";
import { t } from "i18next";
import { Breadcrumb, message } from "antd";
import styles from "./CreateOrEditEntity.module.scss";
import { ReactComponent as CopyLinkIcon } from '@assets/Icons/link-icon.svg';
import { useAppSelector } from "@core/Redux/hooks";
import { selectTableConfig } from "@core/Redux/store";
import { CommentsEditView } from "@core/VisualComponents/Comments/CommentsEditView";

export interface ICreateOrEditEntityModalProps {
    tableId: string;
    entityId?: string;
    onHide: () => void;
}

export function CreateOrEditEntityModal (props: ICreateOrEditEntityModalProps) {
    const orderChanged = useRef<boolean>(false);
    const externalCommands = useRef<ICreateOrEditEntityCommands>({});
    const [isLoading, setIsLoading] = useState<boolean>(true);
    const [editingComments, setEditingComments] = useState<string | null>(null);

    const tableConfig = useAppSelector(selectTableConfig(props.tableId));
    const entityFields = tableConfig?.fields || [];

    const onHide = () => {
        let confirmed = true;
        if (orderChanged.current) {
            // eslint-disable-next-line no-restricted-globals
            confirmed = confirm(t("confirm-drop-changes"));
        }

        return confirmed;
    }

    const onSave = () => {
        return !!externalCommands.current.onCreate?.()
            || !!externalCommands.current.onUpdate?.();
    }

    const onCopyLink = () => {
        navigator.clipboard.writeText(window.location.origin + "/" + props.tableId + "/edit/" + props.entityId);
        message.success(t("link-copied"));
    }

    return <ModalWindow
        title={<>
            <Breadcrumb className={styles.breadcrumb} items={[
                { title: props.entityId ? t("edit-record") : t("new-record") },
            ]}/>
            {props.entityId && !isLoading && <CopyLinkIcon className={styles.copyIcon} onClick={onCopyLink}/>}
        </>}
        beforeHide={onHide}
        onHide={props.onHide}
        beforeSave={onSave}
        onSave={isLoading ? undefined : () => {}}
        saveButtonText={props.entityId ? t("save") : t("create")}
    >
        <CreateOrEditEntity
            tableId={props.tableId}
            entityId={props.entityId}
            orderChanged={orderChanged}
            onCreateOrUpdateOrderClicked={props.onHide}
            onCancelClicked={onHide}
            externalCommands={externalCommands}
            onLoaded={() => setIsLoading(false)}
            onOpenComments={setEditingComments}
        />
        {editingComments != null && props.entityId != null &&
            <ModalWindow
                onHide={() => setEditingComments(null)}
                title={entityFields.find(x => x.id == editingComments)!.caption}
                hideMask
                styles={{
                    body: { padding: 0 }
                }}
            >
                <CommentsEditView
                    field={entityFields.find(x => x.id == editingComments)!}
                    tableId={props.tableId}
                    entityId={props.entityId}
                    isReversed
                />
            </ModalWindow>
        }
    </ModalWindow>
}